import { render, staticRenderFns } from "./StockOrders.vue?vue&type=template&id=3c1036b8"
import script from "./StockOrders.vue?vue&type=script&lang=js"
export * from "./StockOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports